module.exports = __webpack_public_path__ + "static/img/理想 L6.bd1372da.png";